export default "__VITE_ASSET__BboPFpo8__"